module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/superfry-e36ae3db4697d0937af66edef73c70ad.jpg";